import FondEditForm from "../../components/Fonds/FondEditForm";
import { NavLink, useParams } from "react-router";

import { useFondByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function FondEdit(){
    const params = useParams();
    const {translate}=useTrads();
    const { data: fond, error, isLoading } = useFondByIdQuery(params.fondId??"0");

    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>

        ) : fond ? (
            <div>
                <nav>
                    <ul  className="nav nav-tabs">
                        <li className="nav-item"><NavLink className="nav-link" to={`/fond/${params.fondId??"0"}/edit`}>{translate('btn_fond_edit')}</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link" to={`/fond/${params.fondId??"0"}/operators`}>{translate('btn_fond_edit_operators')}</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link" to={`/fond/${params.fondId??"0"}/beneficiaires`}>{translate('btn_fond_edit_beneficiaires')}</NavLink></li>
                    </ul>
                </nav>

                <FondEditForm fondParam={fond}></FondEditForm>

            </div>

        ):null
    );
}
export default FondEdit;